import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { MdHourglassFull } from "react-icons/md";
import { toast } from "react-toastify";
import useAuth from "../../contexts/useAuth";
import { Constants } from "../../libs/Constants";
import { getList } from "../../libs/dbFunctions";
import AddBankAccountButton from "./AddBankAccountButton";
import useEmployeeContext from "./contexts/useEmployeeContext";
import LoanAgreementButton from "./LoanAgreementButton";
import NotificationLayout from "./NotificationLayout";
import ReverifyCustomer from "./ReverifyCustomer";
import UploadBankAccountButton from "./UploadBankAccountButton";
import { VerifyBankAccount } from "./VerifyBankAccount";
export const showBankAcccount = (employee) => {
  if (
    employee?.contributionAmount &&
    employee.acceptTerms &&
    employee?.dwolla_customer_id &&
    employee?.dwolla_customer_status &&
    employee?.dwolla_customer_status === "verified" &&
    employee?.bank_information && // Check if primary account is verified
    employee?.accounts?.find(
      (a) => a.id === employee?.bank_information && a.status === "verified"
    )
  ) {
    // Check if customer verified
    return false;
  }
  return true;
};
const BankAccountSetup = () => {
  const { refreshEmployee, employee } = useEmployeeContext();
  const [employeeData, setEmployeeData] = React.useState(null);
  const [plan, setPlan] = React.useState(null);
  const { activeCompany } = useAuth();
  const [openLoanAgreement, setOpenLoanAgreement] = React.useState(false);
  const [openAddBankAccount, setOpenAddBankAccount] = React.useState(false);

  React.useEffect(() => {
    setEmployeeData({ ...employee });
    if (employee && !plan && activeCompany) {
      getPlanDetail();
    }
  }, [employee, activeCompany]);

  const getPlanDetail = async () => {
    try {
      let planDetail = await getList(
        Constants.dbTypes.PLAN_DETAILS,
        activeCompany
      );
      if (planDetail && planDetail.length > 0) {
        setPlan(planDetail[0]);
      }
    } catch (e) {
      toast.error(e);
    }
  };

  if (!employee && !plan) {
    return <></>;
  }
  const isPrimaryMicroDeposit = () => {
    return (
      employee?.accounts &&
      employee?.accounts.length > 0 &&
      employee?.accounts.find(
        (acc) =>
          acc.microDepositAccount === true &&
          acc.id === employee?.bank_information
      )
    );
  };
  const renderNotificationOnAccountVerified = () => {
    // Check if user has started the verification
    if (!employee?.dwolla_verification_status) {
      // It might happen that for instant verfication it is taking 1-2 seconds
      if (isPrimaryMicroDeposit()) {
        return (
          <NotificationLayout
            title="Verify Bank Account"
            subtitle={
              "A deposit will be made into your bank account. This may take 1-2 business days. You will receive an email once this deposit has been made."
            }
            button={
              <VerifyBankAccount
                onSuccess={(newEmployee) => {
                  setEmployeeData(newEmployee);
                  refreshEmployee();
                }}
              />
            }
          />
        );
      }
    } else if (
      employee?.dwolla_verification_status ===
      Constants.DWOLLA_CUSTOMER_STATUS.IN_PROGRESS
    ) {
      // check if accounts are present or not
      if (isPrimaryMicroDeposit()) {
        return (
          <NotificationLayout
            title="Connect Bank Account"
            subtitle={
              "Verification in process, you will receive an email in the next 2-3 days."
            }
            button={renderStatus("In Progress")}
          />
        );
      }
    } else if (
      employee?.dwolla_verification_status ===
      Constants.DWOLLA_CUSTOMER_STATUS.VERIFIED
    ) {
      return (
        <NotificationLayout
          title="Connect Bank Account"
          subtitle={
            "So we can deposit the amount equal to your contribution, please verify your bank using our partner Dwolla."
          }
          button={renderStatus("Complete")}
        />
      );
    }
    else if (
      employee?.dwolla_verification_statu.length !== 0
    ) {
      return (
        <NotificationLayout
          title="Connect Bank Account"
          subtitle={
            "So we can deposit the amount equal to your contribution, please verify your bank using our partner Dwolla."
          }
          button={renderStatus("Waiting for update")}
        />
      );
    }
    return (
      <></>
    )

  };

  const renderStatus = (status) => {
    return (
      <div className="mt-2">
        <div className="d-flex align-items-center">
          <div className="fw-bold">{status}</div>
          {status === "Complete" && <FaCheckCircle className="ms-1" />}
          {status === "In Progress" && <MdHourglassFull className="ms-1" />}
        </div>
      </div>
    );
  };
  const renderNotificationForCustomerStatus = () => {
    switch (employee.dwolla_customer_status) {
      case Constants.DWOLLA_CUSTOMER_STATUS.IN_PROGRESS:
      case Constants.DWOLLA_CUSTOMER_STATUS.UNVERIFIED:
        return (
          <NotificationLayout
            title="Connect Bank Account"
            subtitle={
              "So we can deposit the amount equal to your contribution, please verify your bank using our partner Dwolla."
            }
            button={renderStatus("In Progress")}
          />
        );
      case Constants.DWOLLA_CUSTOMER_STATUS.REVERIFICATION:
        return (
          <NotificationLayout
            title="Connect Bank Account"
            subtitle={
              "Customer verification has failed. Please re-enter your customer information."
            }
            button={<ReverifyCustomer />}
          />
        );
      case Constants.DWOLLA_CUSTOMER_STATUS.SUSPENDED:
        return (
          <NotificationLayout
            title="Connect Bank Account"
            subtitle={"Your account is suspended. Please email support."}
            button={<></>}
          />
        );
      case Constants.DWOLLA_CUSTOMER_STATUS.DOCUMENT:
        return (
          <NotificationLayout
            title="Connect Bank Account"
            subtitle={
              "We need further documentation to verify your account. Please email support"
            }
            button={<></>}
          />
        );
      case Constants.DWOLLA_CUSTOMER_STATUS.VERIFIED:
        // check if account are present or not
        if (!employee?.accounts || employee.accounts.length === 0) {
          return (
            <NotificationLayout
              title="Connect Bank Account"
              subtitle={
                "So we can deposit the amount equal to your contribution, please verify your bank using our partner Dwolla."
              }
              button={
                <AddBankAccountButton
                  openModal={openAddBankAccount}
                  onSuccess={(newEmployee) => {
                    setEmployeeData(newEmployee);
                    refreshEmployee();
                  }}
                />
              }
            />
          );
        } else {
          return renderNotificationOnAccountVerified();
        }
      default:
        return <></>;
    }
  };
  const renderButtons = () => {
    if (!employeeData?.contributionAmount) {
      return (
        <NotificationLayout
          title=" Connect Bank Account"
          subtitle={
            "So we can deposit the amount equal to your contribution, please verify your bank using our partner Dwolla."
          }
          button={
            <UploadBankAccountButton
              employee={employeeData}
              plan={plan}
              onSuccess={(newEmployee) => {
                setEmployeeData(newEmployee);
                refreshEmployee();
                setOpenLoanAgreement(true);
              }}
            />
          }
        />
      );
    }
    if (!employeeData?.acceptTerms) {
      return (
        <NotificationLayout
          title="Connect Bank Account"
          subtitle={
            "So we can deposit the amount equal to your contribution, please verify your bank using our partner Dwolla."
          }
          button={
            <LoanAgreementButton
              plan={plan}
              employee={employeeData}
              openModal={openLoanAgreement}
              onSuccess={(newEmployee) => {
                setEmployeeData(newEmployee);
                refreshEmployee();
                setOpenAddBankAccount(true);
              }}
            />
          }
        />
      );
    }

    return renderNotificationForCustomerStatus();
  };

  return (
    <div className="bg-pink px-4 py-3 font-secondary mt-1">
      {renderButtons()}
    </div>
  );
};

export default BankAccountSetup;
